/** Dispatched when subscription purchase tickets change (for admin sidebar badge). */
export const SUBSCRIPTION_PURCHASE_TICKETS_UPDATED_EVENT = 'naati:subscription-purchase-tickets-updated';

export function notifySubscriptionPurchaseTicketsUpdated(): void {
  window.dispatchEvent(new CustomEvent(SUBSCRIPTION_PURCHASE_TICKETS_UPDATED_EVENT));
}
